import {CommandGetTraceList} from "@services/tracer/commands/cmdGetTraceList.ts";
import {CommandGetTraceDetails} from "@services/tracer/commands/cmdGetTraceDetails.ts";
export class TracerService {

    async getTraceList(httpMethod='ALL', status='All', search='', employeeId=-1,limit=100, offset= 0) {
        const cmd = new CommandGetTraceList();
        const results = await cmd.run(httpMethod, status, search, employeeId, limit, offset);
        return results;
    }

    async getTrace(traceId:number) {
        const cmd = new CommandGetTraceDetails();
        const results = await cmd.run(traceId);
        return results;
    }

}

